import { Address } from '@anyx/shared-utils';

export const PhoneDisplay = ({ address }: { address: Address; hasPrevious: boolean }) => {
  return address?.phone?.number ? <span>{address?.phone?.number}</span> : null;
};
